export default __webpack_public_path__ + "static/media/08.ca8e553d.jpg";